import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Reset the scroll position to the top on every route change. Behave like a
 * traditional page load rather than an SPA remnant of a prior scroll position.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname])

  return null
}
